// extracted by mini-css-extract-plugin
export default {"titles":"ClickableTitle_titles__9MKST","arrow":"ClickableTitle_arrow__BKVNP","positionArrow":"ClickableTitle_positionArrow__-2BYs"};